<template>
<div class='slider_box' v-if="pages.length>0">
		
	<slider ref="slider" :options="sliderinit">
        <!-- slideritem wrapped package with the components you need -->
        <slideritem v-for="(item,index) in pages" :key="index" :style="item.style">{{item.title}}</slideritem>
        <!-- Customizable loading -->
        <div slot="loading">loading...</div>
   </slider>
</div>
</template>

<script>
'use strict'
import { slider, slideritem }  from 'vue-concise-slider'// 引入slider组件
export default {
  name: 'company_product_introduction',
  data () {
	    return {
	        //图片列表[arr]
	        pages:[
		        {
		            title: '',
		            style:{
		            	background:'url(./static/lunbo/case_1.png)',
		            	'background-repeat': 'no-repeat'
		            }
		        },
		        {
		            title: '',
		            style:{
		            	background:'url(./static/lunbo/case_2.png)',
		            	'background-repeat': 'no-repeat'
		            }
		        }
	        ],
	        //滑动配置[obj]
	        sliderinit: {
	            currentPage: 0,//当前页码
	            thresholdDistance: 1000,//滑动判定距离
	            thresholdTime: 1000,//滑动判定时间
	            autoplay:10000,//自动滚动[ms]
	            loop:true,//循环滚动
	            direction:'horizontal',//方向设置，垂直滚动
	            infinite:1,//无限滚动前后遍历数
	            slidesToScroll:1,//每次滑动项数
	        }
	    }
	},
    components: {
	    slider,
        slideritem
	},
	methods: {
		
   
	}
}
</script>

<style>
.slider_box{
	width: 100%;
	height: 100%;
	z-index: 2;
}
</style>


// WEBPACK FOOTER //
// src/components/product_case/product_case.vue